/**
 * Order of the onboarding wizard screens that carry the step indicator:
 * `/basic-info` followed by the nine survey questions `/survey/q1` … `/survey/q9`.
 * `/upload-image` and the match screens sit outside the indicator.
 */
export const ONBOARDING_STEPS = [
  '/basic-info',
  '/survey/q1',
  '/survey/q2',
  '/survey/q3',
  '/survey/q4',
  '/survey/q5',
  '/survey/q6',
  '/survey/q7',
  '/survey/q8',
  '/survey/q9',
] as const;

export const ONBOARDING_STEP_TOTAL = ONBOARDING_STEPS.length;

export const BASIC_INFO_STEP = 1;

/** Survey question `n` is the step after `/basic-info`. */
export const surveyQuestionStep = (questionNumber: number): number =>
  Math.min(Math.max(BASIC_INFO_STEP + questionNumber, 1), ONBOARDING_STEP_TOTAL);
